<template>
  <div
    class="bg_gradation"
    :style="{ minHeight: `${height}px` }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: 0,
    };
  },
  methods: {
    setHeight() {
      this.height = window.screen.height;
    },
  },
  created() {
    this.setHeight();

  },
};
</script>

<style lang="css" scoped>
.bg_gradation {
  background-image: url('../../assets/images/welcomeCall/bg.svg');
  background-size: cover;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/BgGradation.vue